(function () {
  'use strict';

  var ROOT_ID = 'mmaBlackjackPopup';
  var CONFIG_ID = 'mmaBlackjackConfig';
  var LAST_HAND_KEY = 'mma_blackjack_last_hand_id';
  var DISMISSED_KEY = 'mma_blackjack_dismissed_at';
  var CLAIMED_KEY = 'mma_blackjack_claimed_at';
  var SESSION_OPEN_KEY = 'mma_blackjack_session_opened_at';
  var SESSION_ID_KEY = 'mma_blackjack_session_id';
  var CHECKOUT_EMAIL_KEY = 'mma_capture_checkout_email';
  var LEGACY_CHECKOUT_EMAIL_KEY = 'mma_blackjack_checkout_email';
  var CHECKOUT_PHONE_KEY = 'mma_blackjack_checkout_phone';
  var ORDER_CODE_KEY = 'mma_blackjack_order_code';
  var ORDER_EXPIRES_KEY = 'mma_blackjack_order_expires_at';
  var BODY_LOCK_CLASS = 'mma-blackjack-popup-open';

  var HANDS = [
    {
      id: 'h14-d6',
      player: [{ rank: 'K', suit: 'H' }, { rank: '4', suit: 'S' }],
      hit: { rank: '7', suit: 'D' },
      dealer: [{ rank: '6', suit: 'S' }, { rank: '2', suit: 'H' }],
      dealerDraws: [{ rank: '5', suit: 'H' }, { rank: 'Q', suit: 'C' }]
    },
    {
      id: 'h16-d5',
      player: [{ rank: '9', suit: 'C' }, { rank: '7', suit: 'D' }],
      hit: { rank: '5', suit: 'S' },
      dealer: [{ rank: '5', suit: 'H' }, { rank: '4', suit: 'C' }],
      dealerDraws: [{ rank: '6', suit: 'S' }, { rank: 'K', suit: 'D' }]
    },
    {
      id: 'h15-d4',
      player: [{ rank: 'Q', suit: 'S' }, { rank: '5', suit: 'D' }],
      hit: { rank: '6', suit: 'C' },
      dealer: [{ rank: '4', suit: 'S' }, { rank: '6', suit: 'H' }],
      dealerDraws: [{ rank: '5', suit: 'C' }, { rank: '9', suit: 'H' }]
    },
    {
      id: 'h16-d6',
      player: [{ rank: '8', suit: 'H' }, { rank: '8', suit: 'C' }],
      hit: { rank: '4', suit: 'H' },
      dealer: [{ rank: '6', suit: 'D' }, { rank: '3', suit: 'S' }],
      dealerDraws: [{ rank: '5', suit: 'D' }, { rank: 'K', suit: 'C' }]
    },
    {
      id: 'h18-d5',
      player: [{ rank: 'A', suit: 'S' }, { rank: '7', suit: 'H' }],
      hit: { rank: '2', suit: 'D' },
      dealer: [{ rank: '5', suit: 'C' }, { rank: '7', suit: 'S' }],
      dealerDraws: [{ rank: 'Q', suit: 'D' }]
    }
  ];

  var EVENT_MAP = {
    mma_blackjack_eligible: 'mma_capture_eligible',
    mma_blackjack_open: 'mma_capture_open',
    mma_blackjack_close: 'mma_capture_close',
    mma_blackjack_hit: 'mma_capture_engage',
    mma_blackjack_stand: 'mma_capture_engage',
    mma_blackjack_email_view: 'mma_capture_email_view',
    mma_blackjack_email_focus: 'mma_capture_email_focus',
    mma_blackjack_email_submit: 'mma_capture_email_submit',
    mma_blackjack_email_success: 'mma_capture_email_success',
    mma_blackjack_phone_submit: 'mma_capture_phone_submit',
    mma_blackjack_phone_success: 'mma_capture_phone_success',
    mma_blackjack_final_view: 'mma_capture_success_view',
    mma_blackjack_shop_click: 'mma_capture_shop_click'
  };

  var RYBBIT_CAPTURE_EVENT_MAP = {
    mma_capture_open: 'email_capture_open',
    mma_capture_email_submit: 'email_capture_submit',
    mma_capture_email_success: 'email_collected'
  };

  function parseConfig() {
    var node = document.getElementById(CONFIG_ID);
    var parsed = {};
    if (node) {
      try {
        parsed = JSON.parse(node.textContent || '{}');
      } catch (error) {
        parsed = {};
      }
    }

    return Object.assign({
      enabled: false,
      forceOpen: false,
      mockMode: false,
      endpoint: '',
      pageType: 'unknown',
      pagePath: window.location.pathname,
      allowedPageTypes: ['index', 'collection', 'product'],
      delayMs: 13000,
      cooldownMs: 2 * 24 * 60 * 60 * 1000,
      sessionSuppressAfterOpen: true,
      knownSubscriber: false,
      experimentName: 'capture_challenger_2026q3',
      experimentVariant: 'blackjack_v1',
      allocationVersion: 'v1-50-50',
      experimentAssignmentId: '',
      ga4MeasurementId: 'G-PKHVJ3LX7Z',
      shopUrl: '/collections/best-sellers',
      welcomeListId: 'RbeYBs',
      popupId: 'mma_blackjack_v1_202608',
      popupName: 'MMA Warehouse Blackjack Capture Challenger',
      orderCodeHours: 48,
      shippingCodeHours: 48
    }, parsed || {});
  }

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (error) { /* no-op */ }
  }

  function sessionGet(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function sessionSet(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) { /* no-op */ }
  }

  function randomId(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return prefix + '-' + window.crypto.randomUUID();
    }
    return prefix + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }

  function randomCode(prefix) {
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    var value = '';
    for (var i = 0; i < 8; i += 1) {
      value += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return prefix + value;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function parseQueryFlag(name) {
    var value = new URLSearchParams(window.location.search).get(name);
    return value === '1' || value === 'true';
  }

  function selectHand() {
    var forcedId = new URLSearchParams(window.location.search).get('mma_blackjack_hand');
    var forced = HANDS.find(function (hand) { return hand.id === forcedId; });
    if (forced) return forced;

    var lastId = storageGet(LAST_HAND_KEY);
    var choices = HANDS.filter(function (hand) { return hand.id !== lastId; });
    var pool = choices.length ? choices : HANDS;
    var hand = pool[Math.floor(Math.random() * pool.length)];
    storageSet(LAST_HAND_KEY, hand.id);
    return hand;
  }

  function scoreCards(cards) {
    var total = 0;
    var aces = 0;
    cards.forEach(function (card) {
      if (card.rank === 'A') {
        total += 11;
        aces += 1;
      } else if (['K', 'Q', 'J'].includes(card.rank)) {
        total += 10;
      } else {
        total += Number(card.rank);
      }
    });
    while (total > 21 && aces > 0) {
      total -= 10;
      aces -= 1;
    }
    return total;
  }

  function suitEntity(suit) {
    return { H: '&hearts;', D: '&diams;', C: '&clubs;', S: '&spades;' }[suit] || '';
  }

  function cardMarkup(card, options) {
    var opts = options || {};
    if (opts.hidden) {
      return '<div class="mma-blackjack-card mma-blackjack-card--back' + (opts.dealt ? ' is-dealt' : '') + '" aria-label="Face-down card"></div>';
    }
    var redClass = card.suit === 'H' || card.suit === 'D' ? ' is-red' : '';
    var dealtClass = opts.dealt ? ' is-dealt' : '';
    var suit = suitEntity(card.suit);
    return [
      '<div class="mma-blackjack-card' + redClass + dealtClass + '" aria-label="' + escapeHtml(card.rank + ' of ' + card.suit) + '">',
      '  <span class="mma-blackjack-card__corner"><span>' + escapeHtml(card.rank) + '</span><span class="mma-blackjack-card__suit">' + suit + '</span></span>',
      '  <span class="mma-blackjack-card__center" aria-hidden="true">' + suit + '</span>',
      '</div>'
    ].join('');
  }

  function closeIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  }

  function copyIcon() {
    return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><rect x="8" y="8" width="10" height="11" rx="1" fill="none" stroke="currentColor" stroke-width="2"/><path d="M15 8V5H5v11h3" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
  }

  function popupMarkup() {
    return [
      '<div class="mma-blackjack-popup__backdrop" aria-hidden="true"></div>',
      '<section class="mma-blackjack-popup__dialog" role="dialog" aria-modal="true" aria-labelledby="mmaBlackjackTitle" tabindex="-1">',
      '  <button class="mma-blackjack-popup__close" type="button" aria-label="Close offer" data-bj-close>' + closeIcon() + '</button>',
      '  <div class="mma-blackjack-popup__viewport" data-bj-viewport>',
      '    <article class="mma-blackjack-popup__screen mma-blackjack-popup__screen--game" data-bj-screen="game">',
      '      <div class="mma-blackjack-popup__copy">',
      '        <p class="mma-blackjack-popup__brand">One hand. $15 off.</p>',
      '        <h2 class="mma-blackjack-popup__title" id="mmaBlackjackTitle">Beat the dealer.</h2>',
      '        <p class="mma-blackjack-popup__body">Get closer to 21 than the dealer without going over. Win, and the reward is yours on your first <strong>$150+ order</strong>.</p>',
      '        <p class="mma-blackjack-popup__rule"><strong>HIT</strong> takes another card. <strong>STAND</strong> keeps your hand.</p>',
      '      </div>',
      '      <div class="mma-blackjack-table" aria-label="Blackjack table">',
      '        <div class="mma-blackjack-table__row">',
      '          <div class="mma-blackjack-table__label"><span>Dealer</span><span class="mma-blackjack-score" data-bj-dealer-score>?</span></div>',
      '          <div class="mma-blackjack-cards" data-bj-dealer-cards></div>',
      '        </div>',
      '        <div class="mma-blackjack-table__row">',
      '          <div class="mma-blackjack-table__label"><span>Your hand</span><span class="mma-blackjack-score" data-bj-player-score></span></div>',
      '          <div class="mma-blackjack-cards" data-bj-player-cards></div>',
      '        </div>',
      '        <div class="mma-blackjack-table__status" aria-live="polite" data-bj-status>Choose your move.</div>',
      '        <div class="mma-blackjack-table__actions">',
      '          <button class="mma-blackjack-button mma-blackjack-button--primary" type="button" data-bj-action="hit">Hit</button>',
      '          <button class="mma-blackjack-button mma-blackjack-button--secondary" type="button" data-bj-action="stand">Stand</button>',
      '        </div>',
      '      </div>',
      '    </article>',
      '    <article class="mma-blackjack-popup__screen mma-blackjack-popup__screen--claim" data-bj-screen="email">',
      '      <div class="mma-blackjack-popup__result-copy">',
      '        <p class="mma-blackjack-popup__brand">You beat the dealer</p>',
      '        <h2 class="mma-blackjack-popup__title mma-blackjack-popup__title--wide">Dealer busts.</h2>',
      '        <p class="mma-blackjack-popup__body">The house went over. Your $15 is yours.</p>',
      '      </div>',
      '      <div class="mma-blackjack-popup__form-wrap">',
      '        <div class="mma-blackjack-result">',
      '          <p class="mma-blackjack-result__eyebrow">You won</p>',
      '          <p class="mma-blackjack-result__amount">$15 off</p>',
      '          <p class="mma-blackjack-result__detail">Your first $150+ order</p>',
      '        </div>',
      '        <form class="mma-blackjack-form" data-bj-email-form novalidate>',
      '          <label class="mma-blackjack-field">',
      '            <span class="mma-blackjack-field__label">Email address</span>',
      '            <span class="mma-blackjack-input-wrap"><input class="mma-blackjack-input" type="email" inputmode="email" autocomplete="email" placeholder="you@example.com" required data-bj-email></span>',
      '          </label>',
      '          <p class="mma-blackjack-form__error" data-bj-email-error aria-live="polite"></p>',
      '          <button class="mma-blackjack-button mma-blackjack-button--primary" type="submit" data-bj-email-submit>Claim my $15</button>',
      '          <p class="mma-blackjack-legal">By signing up, you agree to receive MMA Warehouse emails. Unsubscribe anytime.</p>',
      '        </form>',
      '      </div>',
      '    </article>',
      '    <article class="mma-blackjack-popup__screen mma-blackjack-popup__screen--double" data-bj-screen="double">',
      '      <div class="mma-blackjack-popup__result-copy">',
      '        <p class="mma-blackjack-popup__brand">Your $15 is claimed</p>',
      '        <h2 class="mma-blackjack-popup__title mma-blackjack-popup__title--wide">Double down?</h2>',
      '        <p class="mma-blackjack-popup__body">It\'s saved to your cart and on its way to your inbox. Add your mobile number to flip one last card and unlock <strong>free shipping</strong> too.</p>',
      '      </div>',
      '      <div class="mma-blackjack-popup__form-wrap">',
      '        <form class="mma-blackjack-form" data-bj-phone-form novalidate>',
      '          <label class="mma-blackjack-field">',
      '            <span class="mma-blackjack-field__label">US mobile number</span>',
      '            <span class="mma-blackjack-input-wrap"><span class="mma-blackjack-input-prefix">+1</span><input class="mma-blackjack-input" type="tel" inputmode="tel" autocomplete="tel-national" placeholder="(555) 555-0123" required data-bj-phone></span>',
      '          </label>',
      '          <p class="mma-blackjack-form__error" data-bj-phone-error aria-live="polite"></p>',
      '          <button class="mma-blackjack-button mma-blackjack-button--primary" type="submit" data-bj-phone-submit>Flip the last card</button>',
      '          <p class="mma-blackjack-legal">By submitting, you agree to receive recurring automated promotional and personalized marketing text messages from MMA Warehouse at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Reply STOP to cancel, HELP for help. Message frequency varies. View <a href="/policies/terms-of-service" target="_blank" rel="noopener">Terms</a> &amp; <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</p>',
      '          <button class="mma-blackjack-skip" type="button" data-bj-skip>No thanks, keep my $15</button>',
      '        </form>',
      '      </div>',
      '      <div class="mma-blackjack-double-card" aria-label="Face-down Double Down card">' + cardMarkup(null, { hidden: true }) + '</div>',
      '    </article>',
      '    <article class="mma-blackjack-popup__screen mma-blackjack-popup__screen--final" data-bj-screen="final">',
      '      <div class="mma-blackjack-popup__result-copy">',
      '        <p class="mma-blackjack-popup__brand" data-bj-final-eyebrow>The house pays twice</p>',
      '        <h2 class="mma-blackjack-popup__title mma-blackjack-popup__title--wide" data-bj-final-title>$15 off + free shipping.</h2>',
      '        <p class="mma-blackjack-popup__body" data-bj-final-body>Both rewards are ready for your first $150+ order.</p>',
      '      </div>',
      '      <div class="mma-blackjack-popup__form-wrap">',
      '        <div class="mma-blackjack-code-list">',
      '          <div class="mma-blackjack-code">',
      '            <div><span class="mma-blackjack-code__label">$15 backup code</span><strong class="mma-blackjack-code__value" data-bj-order-code>Loading...</strong></div>',
      '            <button class="mma-blackjack-code__copy" type="button" aria-label="Copy $15 code" data-bj-copy="order">' + copyIcon() + '</button>',
      '          </div>',
      '          <div class="mma-blackjack-code" data-bj-shipping-row>',
      '            <div><span class="mma-blackjack-code__label">Free shipping backup code</span><strong class="mma-blackjack-code__value" data-bj-shipping-code>Loading...</strong></div>',
      '            <button class="mma-blackjack-code__copy" type="button" aria-label="Copy free shipping code" data-bj-copy="shipping">' + copyIcon() + '</button>',
      '          </div>',
      '        </div>',
      '        <div class="mma-blackjack-final-actions"><a class="mma-blackjack-button mma-blackjack-button--primary" href="/collections/best-sellers" data-bj-shop>Shop with both applied</a></div>',
      '        <p class="mma-blackjack-expiry" data-bj-expiry>First order only. $150 minimum. One use per customer.</p>',
      '      </div>',
      '    </article>',
      '  </div>',
      '  <div class="mma-blackjack-toast" role="status" aria-live="polite" data-bj-toast></div>',
      '</section>'
    ].join('');
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root || root.dataset.blackjackReady === 'true') return;
    root.dataset.blackjackReady = 'true';

    var config = parseConfig();
    var queryForce = parseQueryFlag('mma_blackjack_popup');
    var queryMock = parseQueryFlag('mma_blackjack_popup_mock');
    if (queryForce) config.forceOpen = true;
    if (queryMock) config.mockMode = true;
    root.innerHTML = popupMarkup();
    root.querySelector('[data-bj-shop]').setAttribute('href', config.shopUrl || '/collections/best-sellers');

    var state = {
      hand: selectHand(),
      playerCards: [],
      dealerCards: [],
      decision: '',
      resolving: false,
      gameId: randomId('mma-blackjack-game'),
      claimId: '',
      gameToken: '',
      secondRewardToken: '',
      email: '',
      phone: '',
      orderCode: '',
      orderExpiresAt: '',
      shippingCode: '',
      shippingExpiresAt: '',
      initialDealDone: false,
      open: false,
      lastFocused: null
    };
    root.dataset.handId = state.hand.id;
    root.dataset.eventCount = '0';

    var dialog = root.querySelector('.mma-blackjack-popup__dialog');
    var viewport = root.querySelector('[data-bj-viewport]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function sessionId() {
      var existing = sessionGet(SESSION_ID_KEY);
      if (existing) return existing;
      var created = randomId('mma-blackjack-session');
      sessionSet(SESSION_ID_KEY, created);
      return created;
    }

    function enhanceCheckoutUrl(value) {
      var raw = String(value || '/checkout');
      try {
        var url = new URL(raw, window.location.origin);
        var email = String(sessionGet(CHECKOUT_EMAIL_KEY) || sessionGet(LEGACY_CHECKOUT_EMAIL_KEY) || '').trim().toLowerCase();
        var phone = normalizeUsPhone(sessionGet(CHECKOUT_PHONE_KEY));
        var hasEmail = validEmail(email);
        if (!hasEmail && !phone) return raw;

        if (url.origin === window.location.origin) {
          var routesRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
          url.pathname = String(routesRoot).replace(/\/?$/, '/') + 'cart/checkout';
        }
        if (hasEmail) url.searchParams.set('checkout[email]', email);
        if (phone) url.searchParams.set('checkout[shipping_address][phone]', phone);
        if (url.origin === window.location.origin) {
          return url.pathname + url.search + url.hash;
        }
        return url.toString();
      } catch (error) {
        return raw;
      }
    }

    function setCheckoutEmail(value) {
      var email = String(value || '').trim().toLowerCase();
      if (!validEmail(email)) return false;
      sessionSet(CHECKOUT_EMAIL_KEY, email);
      return true;
    }

    window.MmaBlackjackCheckout = {
      enhanceUrl: enhanceCheckoutUrl,
      setEmail: setCheckoutEmail
    };

    function eventParams(extra) {
      return Object.assign({
        capture_experience: 'blackjack_v1',
        experiment_name: config.experimentName,
        experiment_variant: config.experimentVariant,
        allocation_version: config.allocationVersion,
        capture_assignment_id: config.experimentAssignmentId,
        popup_id: config.popupId,
        popup_name: config.popupName,
        game_id: state.gameId,
        hand_id: state.hand.id,
        blackjack_player_action: state.decision,
        claim_id: state.claimId,
        page_type: config.pageType,
        page_path: config.pagePath || window.location.pathname,
        session_id: sessionId(),
        event_source: 'mma_blackjack_popup'
      }, extra || {});
    }

    function dispatchEvent(name, params) {
      var payload = eventParams(params);
      root.dataset.lastEvent = name;
      root.dataset.eventCount = String(Number(root.dataset.eventCount || 0) + 1);
      if (config.mockMode) {
        var eventLog = String(root.dataset.eventLog || '').split(',').filter(Boolean);
        eventLog.push(name);
        root.dataset.eventLog = eventLog.slice(-40).join(',');
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('event', name, Object.assign({}, payload, {
        send_to: config.ga4MeasurementId
      }));
      document.dispatchEvent(new CustomEvent(name, { detail: payload }));
    }

    function trackRybbitCapture(sharedName, params) {
      var eventName = RYBBIT_CAPTURE_EVENT_MAP[sharedName];
      if (!eventName || config.mockMode || typeof window.ryb !== 'function') return;

      var props = params || {};
      window.ryb(eventName, {
        source: 'blackjack_popup',
        capture_experience: 'blackjack_v1',
        experiment_name: config.experimentName,
        experiment_variant: config.experimentVariant,
        allocation_version: config.allocationVersion,
        page_type: config.pageType,
        page_path: config.pagePath || window.location.pathname,
        offer_type: props.offer_type || 'BLACKJACK_D15_150'
      });
    }

    function track(name, params) {
      dispatchEvent(name, params);
      if (EVENT_MAP[name]) {
        dispatchEvent(EVENT_MAP[name], params);
        trackRybbitCapture(EVENT_MAP[name], params);
      }
    }

    function wait(ms) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, reduceMotion ? 20 : ms);
      });
    }

    function holdResult(ms) {
      return new Promise(function (resolve) {
        window.setTimeout(resolve, reduceMotion ? Math.min(ms, 1000) : ms);
      });
    }

    function showToast(message) {
      var toast = root.querySelector('[data-bj-toast]');
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(showToast.timer);
      showToast.timer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 1800);
    }

    function setStatus(message) {
      root.querySelector('[data-bj-status]').textContent = message;
    }

    function renderInitialHand() {
      state.playerCards = state.hand.player.slice();
      state.dealerCards = [state.hand.dealer[0]];
      root.querySelector('[data-bj-player-cards]').innerHTML = state.playerCards.map(function (card) {
        return cardMarkup(card);
      }).join('');
      root.querySelector('[data-bj-dealer-cards]').innerHTML = cardMarkup(state.hand.dealer[0]) + cardMarkup(null, { hidden: true });
      root.querySelector('[data-bj-player-score]').textContent = scoreCards(state.playerCards);
      root.querySelector('[data-bj-dealer-score]').textContent = state.hand.dealer[0].rank;
    }

    async function dealInitialHand() {
      if (state.initialDealDone) return;
      state.initialDealDone = true;

      var playerTarget = root.querySelector('[data-bj-player-cards]');
      var dealerTarget = root.querySelector('[data-bj-dealer-cards]');
      var playerScore = root.querySelector('[data-bj-player-score]');
      var dealerScore = root.querySelector('[data-bj-dealer-score]');
      var actionButtons = root.querySelectorAll('[data-bj-action]');

      if (reduceMotion) {
        renderInitialHand();
        return;
      }

      state.playerCards = [];
      state.dealerCards = [];
      playerTarget.innerHTML = '';
      dealerTarget.innerHTML = '';
      playerScore.textContent = '?';
      dealerScore.textContent = '?';
      setStatus('Dealing your hand...');
      actionButtons.forEach(function (button) { button.disabled = true; });

      state.playerCards.push(state.hand.player[0]);
      appendCard(playerTarget, state.hand.player[0]);
      playerScore.textContent = scoreCards(state.playerCards);
      await wait(430);

      state.dealerCards.push(state.hand.dealer[0]);
      appendCard(dealerTarget, state.hand.dealer[0]);
      dealerScore.textContent = state.hand.dealer[0].rank;
      await wait(430);

      state.playerCards.push(state.hand.player[1]);
      appendCard(playerTarget, state.hand.player[1]);
      playerScore.textContent = scoreCards(state.playerCards);
      await wait(430);

      dealerTarget.insertAdjacentHTML('beforeend', cardMarkup(null, { hidden: true, dealt: true }));
      await wait(520);

      setStatus('Choose your move.');
      actionButtons.forEach(function (button) { button.disabled = false; });
    }

    function appendCard(target, card) {
      target.insertAdjacentHTML('beforeend', cardMarkup(card, { dealt: true }));
    }

    function showScreen(name) {
      root.querySelectorAll('[data-bj-screen]').forEach(function (screen) {
        screen.classList.toggle('is-active', screen.getAttribute('data-bj-screen') === name);
      });
      viewport.scrollTop = 0;
      dialog.setAttribute('aria-label', {
        game: 'Beat the dealer',
        email: 'Dealer busts. Claim your $15',
        double: 'Double down for free shipping',
        final: 'Your rewards are ready'
      }[name] || 'MMA Warehouse offer');
      if (name === 'email') {
        track('mma_blackjack_email_view');
        window.setTimeout(function () { root.querySelector('[data-bj-email]').focus(); }, reduceMotion ? 20 : 240);
      }
      if (name === 'double') {
        track('mma_blackjack_double_down_view');
        window.setTimeout(function () { root.querySelector('[data-bj-phone]').focus(); }, reduceMotion ? 20 : 240);
      }
      if (name === 'final') track('mma_blackjack_final_view', { double_down_claimed: Boolean(state.shippingCode) });
    }

    async function resolveGame(decision) {
      if (state.resolving) return;
      state.resolving = true;
      state.decision = decision;
      root.querySelectorAll('[data-bj-action]').forEach(function (button) { button.disabled = true; });
      track(decision === 'hit' ? 'mma_blackjack_hit' : 'mma_blackjack_stand');

      if (decision === 'hit') {
        setStatus('One more card...');
        await wait(760);
        state.playerCards.push(state.hand.hit);
        appendCard(root.querySelector('[data-bj-player-cards]'), state.hand.hit);
        root.querySelector('[data-bj-player-score]').textContent = scoreCards(state.playerCards);
        await wait(820);
      } else {
        setStatus('You hold at ' + scoreCards(state.playerCards) + '. Dealer plays.');
        await wait(1040);
      }

      setStatus('Dealer reveals...');
      var dealerTarget = root.querySelector('[data-bj-dealer-cards]');
      state.dealerCards = state.hand.dealer.slice();
      dealerTarget.innerHTML = state.dealerCards.map(function (card, index) {
        return cardMarkup(card, { dealt: index === 1 });
      }).join('');
      root.querySelector('[data-bj-dealer-score]').textContent = scoreCards(state.dealerCards);
      await wait(880);

      for (var i = 0; i < state.hand.dealerDraws.length; i += 1) {
        setStatus('Dealer draws...');
        state.dealerCards.push(state.hand.dealerDraws[i]);
        appendCard(dealerTarget, state.hand.dealerDraws[i]);
        root.querySelector('[data-bj-dealer-score]').textContent = scoreCards(state.dealerCards);
        await wait(760);
      }

      setStatus('Dealer busts at ' + scoreCards(state.dealerCards) + '. You win.');
      track('mma_blackjack_dealer_bust', {
        player_score: scoreCards(state.playerCards),
        dealer_score: scoreCards(state.dealerCards)
      });
      await holdResult(1800);
      showScreen('email');
    }

    function isEligible() {
      if (config.forceOpen) return true;
      if (!config.enabled) return false;
      if (config.knownSubscriber || storageGet(CLAIMED_KEY)) return false;
      if (config.allowedPageTypes.indexOf(config.pageType) === -1) return false;
      if (config.sessionSuppressAfterOpen && sessionGet(SESSION_OPEN_KEY)) return false;
      var dismissedAt = Number(storageGet(DISMISSED_KEY) || 0);
      if (dismissedAt && Date.now() - dismissedAt < Number(config.cooldownMs)) return false;
      return true;
    }

    function openPopup(trigger) {
      if (state.open) return;
      state.open = true;
      state.lastFocused = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add(BODY_LOCK_CLASS);
      document.body.style.overflow = 'hidden';
      sessionSet(SESSION_OPEN_KEY, String(Date.now()));
      track('mma_blackjack_open', { trigger: trigger || 'unknown' });
      dialog.focus();
      startGameSession();
      dealInitialHand();
    }

    function closePopup(reason) {
      if (!state.open) return;
      state.open = false;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove(BODY_LOCK_CLASS);
      document.body.style.overflow = '';
      storageSet(DISMISSED_KEY, String(Date.now()));
      track('mma_blackjack_close', { close_reason: reason || 'close_button' });
      if (state.lastFocused && typeof state.lastFocused.focus === 'function') state.lastFocused.focus();
    }

    async function startGameSession() {
      if (config.mockMode || !config.endpoint) {
        state.claimId = randomId('bj-preview-claim');
        state.gameToken = 'preview-game-token';
        return;
      }
      try {
        var response = await fetch(config.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            action: 'start_blackjack',
            gameId: state.gameId,
            handId: state.hand.id,
            sessionId: sessionId(),
            popupId: config.popupId,
            experimentName: config.experimentName,
            experimentVariant: config.experimentVariant,
            allocationVersion: config.allocationVersion,
            experimentAssignmentId: config.experimentAssignmentId,
            pageType: config.pageType,
            pagePath: config.pagePath
          })
        });
        if (!response.ok) throw new Error('Game start failed');
        var data = await response.json();
        state.claimId = data.claimId;
        state.gameToken = data.gameToken;
      } catch (error) {
        dispatchEvent('mma_blackjack_start_error', { error_type: 'endpoint' });
      }
    }

    function validEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
    }

    function normalizeUsPhone(value) {
      var digits = String(value || '').replace(/\D/g, '');
      if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
      return digits.length === 10 ? '+1' + digits : '';
    }

    function formatExpiry(value) {
      if (!value) return '';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      }).format(date);
    }

    function mockExpiry(hours) {
      return new Date(Date.now() + Number(hours || 48) * 60 * 60 * 1000).toISOString();
    }

    async function updateCartAttribution() {
      if (config.mockMode) return;
      var attributes = {
        mma_capture_experience: 'blackjack_v1',
        mma_capture_experiment_name: config.experimentName,
        mma_capture_experiment_variant: config.experimentVariant,
        mma_capture_allocation_version: config.allocationVersion,
        mma_capture_assignment_id: config.experimentAssignmentId,
        mma_blackjack_claim_id: state.claimId,
        mma_blackjack_hand_id: state.hand.id,
        mma_blackjack_player_action: state.decision,
        mma_blackjack_order_code: state.orderCode,
        mma_blackjack_order_expires_at: state.orderExpiresAt,
        mma_blackjack_shipping_code: state.shippingCode,
        mma_blackjack_shipping_expires_at: state.shippingExpiresAt,
        mma_blackjack_page_type: config.pageType,
        mma_blackjack_page_path: config.pagePath
      };
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        });
        dispatchEvent('mma_blackjack_cart_attribution_success');
      } catch (error) {
        dispatchEvent('mma_blackjack_cart_attribution_error');
      }
    }

    async function applyDiscountCode(code) {
      var response = await fetch(
        '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js',
        {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        }
      );
      if (!response.ok) throw new Error('Discount route failed (' + response.status + ')');
      return response.json();
    }

    async function primeDiscountCodes() {
      var codes = [state.orderCode, state.shippingCode].filter(Boolean);
      if (!codes.length || config.mockMode) return Promise.resolve();

      track('mma_blackjack_discount_apply_start', {
        discount_count: codes.length,
        double_down_claimed: Boolean(state.shippingCode)
      });

      try {
        for (var index = 0; index < codes.length; index += 1) {
          await applyDiscountCode(codes[index]);
        }
        track('mma_blackjack_discount_apply_complete', {
          discount_count: codes.length,
          double_down_claimed: Boolean(state.shippingCode),
          application_route: 'shopify_discount_redirect_cart_js'
        });
      } catch (error) {
        track('mma_blackjack_discount_apply_error', {
          discount_count: codes.length,
          double_down_claimed: Boolean(state.shippingCode),
          error_type: 'shopify_discount_route'
        });
        dispatchEvent('mma_blackjack_discount_apply_error', {
          error_type: 'shopify_discount_route'
        });
      }
    }

    async function claimEmail(event) {
      event.preventDefault();
      var input = root.querySelector('[data-bj-email]');
      var errorNode = root.querySelector('[data-bj-email-error]');
      var submit = root.querySelector('[data-bj-email-submit]');
      var email = String(input.value || '').trim().toLowerCase();
      if (!validEmail(email)) {
        errorNode.textContent = 'Enter a valid email address.';
        input.focus();
        dispatchEvent('mma_blackjack_email_invalid');
        return;
      }

      state.email = email;
      errorNode.textContent = '';
      submit.disabled = true;
      submit.textContent = 'Claiming...';
      track('mma_blackjack_email_submit');

      try {
        var data;
        if (config.mockMode) {
          await wait(720);
          data = {
            code: randomCode('BJ15-'),
            claimId: state.claimId || randomId('bj-preview-claim'),
            expiresAt: mockExpiry(config.orderCodeHours),
            secondRewardToken: 'preview-second-reward-token'
          };
        } else {
          var response = await fetch(config.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'claim_blackjack_email',
              email: email,
              gameToken: state.gameToken,
              claimId: state.claimId,
              gameId: state.gameId,
              handId: state.hand.id,
              playerAction: state.decision,
              listId: config.welcomeListId,
              popupId: config.popupId,
              popupName: config.popupName,
              source: 'MMA Warehouse blackjack popup',
              welcomeEntrySource: 'blackjack_popup',
              experimentName: config.experimentName,
              experimentVariant: config.experimentVariant,
              allocationVersion: config.allocationVersion,
              experimentAssignmentId: config.experimentAssignmentId,
              pageType: config.pageType,
              pagePath: config.pagePath,
              pageUrl: window.location.href
            })
          });
          data = await response.json();
          if (!response.ok || !data.code) throw new Error(data.error || 'Email claim failed');
        }

        state.claimId = data.claimId || state.claimId;
        state.orderCode = data.code;
        state.orderExpiresAt = data.expiresAt;
        state.secondRewardToken = data.secondRewardToken || '';
        setCheckoutEmail(email);
        sessionSet(ORDER_CODE_KEY, state.orderCode);
        sessionSet(ORDER_EXPIRES_KEY, state.orderExpiresAt || '');
        storageSet(CLAIMED_KEY, String(Date.now()));
        track('mma_blackjack_email_success', { coupon_prefix: 'BJ15', offer_type: 'BLACKJACK_D15_150' });
        await updateCartAttribution();
        await primeDiscountCodes();
        showScreen('double');
      } catch (error) {
        errorNode.textContent = 'We could not issue your code. Try again.';
        dispatchEvent('mma_blackjack_email_error', { error_type: 'claim_failed' });
      } finally {
        submit.disabled = false;
        submit.textContent = 'Claim my $15';
      }
    }

    function renderFinal() {
      var hasShipping = Boolean(state.shippingCode);
      var shippingRow = root.querySelector('[data-bj-shipping-row]');
      root.querySelector('[data-bj-order-code]').textContent = state.orderCode;
      root.querySelector('[data-bj-shipping-code]').textContent = hasShipping ? state.shippingCode : '';
      shippingRow.hidden = !hasShipping;
      shippingRow.classList.toggle('is-hidden', !hasShipping);
      shippingRow.setAttribute('aria-hidden', hasShipping ? 'false' : 'true');
      root.querySelector('[data-bj-final-eyebrow]').textContent = hasShipping ? 'The house pays twice' : 'Your reward is ready';
      root.querySelector('[data-bj-final-title]').textContent = hasShipping ? '$15 off + free shipping.' : 'Your $15 is ready.';
      root.querySelector('[data-bj-final-body]').textContent = hasShipping
        ? 'Both rewards are saved to your cart and inbox. Spend $150 to unlock them.'
        : 'Your $15 is saved to your cart and inbox. Spend $150 to unlock it.';
      root.querySelector('[data-bj-shop]').textContent = hasShipping ? 'Shop with my rewards' : 'Shop with my $15';

      var expiry = formatExpiry(hasShipping ? state.shippingExpiresAt : state.orderExpiresAt);
      var expiryText = 'First order only. $150 minimum. One use per customer.';
      if (expiry) expiryText += ' Codes expire ' + expiry + '.';
      if (hasShipping) expiryText += ' Eligible product offers may apply. Other shipping promotions excluded.';
      root.querySelector('[data-bj-expiry]').textContent = expiryText;
      showScreen('final');
    }

    async function revealSecondReward() {
      var target = root.querySelector('.mma-blackjack-double-card');
      target.setAttribute('aria-label', 'Free shipping unlocked');
      target.innerHTML = '<div class="mma-blackjack-reward-card"><span>Second reward</span><strong>Free shipping</strong></div>';
      await wait(1050);
    }

    async function claimPhone(event) {
      event.preventDefault();
      var input = root.querySelector('[data-bj-phone]');
      var errorNode = root.querySelector('[data-bj-phone-error]');
      var submit = root.querySelector('[data-bj-phone-submit]');
      var phone = normalizeUsPhone(input.value);
      if (!phone) {
        errorNode.textContent = 'Enter a valid 10-digit US mobile number.';
        input.focus();
        dispatchEvent('mma_blackjack_phone_invalid');
        return;
      }

      errorNode.textContent = '';
      submit.disabled = true;
      submit.textContent = 'Flipping...';
      track('mma_blackjack_phone_submit');

      try {
        var data;
        if (config.mockMode) {
          await wait(760);
          data = {
            code: randomCode('BJSHIP-'),
            expiresAt: mockExpiry(config.shippingCodeHours)
          };
        } else {
          var response = await fetch(config.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              action: 'claim_blackjack_sms',
              email: state.email,
              phoneNumber: phone,
              claimId: state.claimId,
              secondRewardToken: state.secondRewardToken,
              gameId: state.gameId,
              handId: state.hand.id,
              playerAction: state.decision,
              popupId: config.popupId,
              popupName: config.popupName,
              source: 'MMA Warehouse blackjack Double Down',
              experimentName: config.experimentName,
              experimentVariant: config.experimentVariant,
              allocationVersion: config.allocationVersion,
              experimentAssignmentId: config.experimentAssignmentId,
              pageType: config.pageType,
              pagePath: config.pagePath,
              pageUrl: window.location.href
            })
          });
          data = await response.json();
          if (!response.ok || !data.code) throw new Error(data.error || 'Phone claim failed');
        }

        state.shippingCode = data.code;
        state.shippingExpiresAt = data.expiresAt;
        state.phone = phone;
        sessionSet(CHECKOUT_PHONE_KEY, phone);
        track('mma_blackjack_phone_success', { coupon_prefix: 'BJSHIP' });
        await updateCartAttribution();
        await primeDiscountCodes();
        await revealSecondReward();
        renderFinal();
      } catch (error) {
        errorNode.textContent = 'We could not unlock free shipping. Try again.';
        dispatchEvent('mma_blackjack_phone_error', { error_type: 'claim_failed' });
      } finally {
        submit.disabled = false;
        submit.textContent = 'Flip the last card';
      }
    }

    function copyCode(kind) {
      var code = kind === 'shipping' ? state.shippingCode : state.orderCode;
      if (!code) return;
      var copy = navigator.clipboard && navigator.clipboard.writeText
        ? navigator.clipboard.writeText(code)
        : Promise.reject(new Error('Clipboard unavailable'));
      copy.then(function () {
        showToast('Code copied.');
      }).catch(function () {
        showToast(code);
      });
      track('mma_blackjack_code_copy', { code_type: kind });
    }

    async function shopClick(event) {
      event.preventDefault();
      track('mma_blackjack_shop_click', { double_down_claimed: Boolean(state.shippingCode) });
      if (config.mockMode) {
        showToast('Preview only. No live cart was changed.');
        return;
      }
      var destination = event.currentTarget.getAttribute('href') || config.shopUrl;
      await updateCartAttribution();
      await primeDiscountCodes();
      window.location.assign(destination);
    }

    root.addEventListener('click', function (event) {
      var close = event.target.closest('[data-bj-close]');
      if (close) {
        closePopup('close_button');
        return;
      }
      var action = event.target.closest('[data-bj-action]');
      if (action) {
        resolveGame(action.getAttribute('data-bj-action'));
        return;
      }
      var skip = event.target.closest('[data-bj-skip]');
      if (skip) {
        state.shippingCode = '';
        state.shippingExpiresAt = '';
        dispatchEvent('mma_blackjack_double_down_skip');
        renderFinal();
        return;
      }
      var copy = event.target.closest('[data-bj-copy]');
      if (copy) {
        copyCode(copy.getAttribute('data-bj-copy'));
      }
    });

    root.querySelector('[data-bj-email-form]').addEventListener('submit', claimEmail);
    root.querySelector('[data-bj-phone-form]').addEventListener('submit', claimPhone);
    root.querySelector('[data-bj-email]').addEventListener('focus', function () { track('mma_blackjack_email_focus'); }, { once: true });
    root.querySelector('[data-bj-shop]').addEventListener('click', shopClick);

    document.addEventListener('keydown', function (event) {
      if (!state.open || event.key !== 'Tab') return;
      var focusable = Array.from(dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]'))
        .filter(function (node) { return node.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    showScreen('game');
    root.setAttribute('aria-hidden', 'true');

    if (isEligible()) {
      track('mma_blackjack_eligible');
      if (config.forceOpen) {
        openPopup('preview');
      } else {
        var opened = false;
        var openOnce = function (trigger) {
          if (opened || !isEligible()) return;
          opened = true;
          openPopup(trigger);
        };
        window.setTimeout(function () { openOnce('delay'); }, Number(config.delayMs));
        document.addEventListener('mouseout', function (event) {
          if (event.clientY <= 0 && !event.relatedTarget) openOnce('exit_intent');
        });
      }
    }

    window.MmaBlackjackPopup = {
      open: function () { openPopup('manual'); },
      close: function () { closePopup('manual'); },
      handId: function () { return state.hand.id; },
      resetPreview: function () {
        storageSet(DISMISSED_KEY, '');
        storageSet(CLAIMED_KEY, '');
        sessionSet(SESSION_OPEN_KEY, '');
        sessionSet(CHECKOUT_EMAIL_KEY, '');
        sessionSet(LEGACY_CHECKOUT_EMAIL_KEY, '');
        sessionSet(CHECKOUT_PHONE_KEY, '');
        window.location.reload();
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
